import React, { useCallback } from "react"
import { signInWithRedirect } from "aws-amplify/auth"
import { Button } from "@aws-amplify/ui-react"

type Props = {
  providerName: string
  setError: React.Dispatch<React.SetStateAction<string | null>>
}

export default function MicrosoftSignInButton({ providerName, setError }: Props) {
  const handleSignIn = useCallback(async () => {
    try {
      await signInWithRedirect({ provider: { custom: providerName } })
    } catch (err) {
      console.error("Microsoft sign-in failed", err)
      setError("Sign-in failed")
    }
  }, [providerName, setError])

  return (
    <Button onClick={handleSignIn} variation="primary" data-testid="microsoft-signin">
      Sign in with Microsoft
    </Button>
  )
}
